<div class="searchbar-whereapp">
  <div id="invia-messaggio-div">
    <button id="invia-messaggio-button" (click)="newMessageDialog()">
      <mat-icon aria-hidden="false" id="invia-messaggio-icon">add</mat-icon>
      <span id="invia-messaggio-text">Nuovo messaggio</span>
    </button>
  </div>

  <div id="search-div">
    <i class="fa fa-filter" aria-hidden="true"></i>
    <input spellcheck="false" type="text" #filter [(ngModel)]="filterValue" placeholder="Filtra per parole chiave"
      (keydown)="onSearchKeydown($event)">
    <i class="fa fa-times" aria-hidden="true" (click)="onFilterClear();onFiltering()"></i>
    <button mat-stroked-button (click)="onFiltering()" class="ml-2" [disabled]="filterValue.length < 4 && filterValue.length > 0">Cerca</button>
  </div>
  <div id="pagination-div">
    <mat-paginator #paginator [hidePageSize]="true" [pageIndex]="pageable.pageable.pageNum" [pageSize]="pageable.pageable.pageSize"
      [length]=totalElements (page)="onPagination($event)" [showFirstLastButtons]="true">
    </mat-paginator>
  </div>
</div>

<mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
</mat-progress-bar>

<div class="empty-list" *ngIf="emptyList">
  <span>Nessun messaggio trovato.</span>
</div>

<div id="main-container">
  <!-- Tabella messaggi -->
  <mat-table [dataSource]="dataSource" matSort [matSortActive]="paginatorConfig.getFilterColumn()" [matSortDirection]="paginatorConfig.getFilterDirection()" [matSortStart]="paginatorConfig.getFilterDirection()"
    matSortDisableClear (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="validity">
      <mat-header-cell *matHeaderCellDef fxFlex="5%" class="mobile-medium">
        <mat-icon>
        </mat-icon>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="5%" class="mobile-medium">
        <i *ngIf="element.validity === 1" matTooltip="Stato del Messaggio: {{ 'Multilang.verification1'| translate }}"
          class="fa fa-clock-o fa-lg" id="pending-icon" aria-hidden="true"></i>
        <i *ngIf="element.validity === 2" matTooltip="Stato del Messaggio: {{ 'Multilang.verification2'| translate }}"
          class="fa fa-arrow-right fa-lg" id="active-icon" aria-hidden="true"></i>
        <i *ngIf="element.validity === 3" matTooltip="Stato del Messaggio: {{ 'Multilang.verification3'| translate }}"
          class="fa fa-check fa-lg" id="expired-icon" aria-hidden="true"></i>
        <!--<i *ngIf="element.validity === 4" matTooltip="{{ 'Multilang.verification4'| translate }}"
          class="fa fa-times fa-lg" id="OLDcancelled-icon" aria-hidden="true"></i>-->
        <i *ngIf="element.validity === 4" matTooltip="Stato del Messaggio: {{ 'Multilang.verification4'| translate }}"
          class="fa fa-close fa-lg" style="color:crimson" id="cancelled-icon" aria-hidden="true"></i>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="senderName">
      <mat-header-cell *matHeaderCellDef fxFlex="30%" fxFlex.sm="25%" fxFlex.xs="30%" class="mobile-large"
        mat-sort-header>
        {{ 'Multilang.messageSender'| translate }} </mat-header-cell>
      <mat-cell *matCellDef="let sender" fxFlex="22%" fxFlex.sm="25%" fxFlex.xs="30%" class="mobile-large"
        style="padding-right: 8px">
        {{sender.senderName}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="area">
      <mat-header-cell *matHeaderCellDef fxFlex="20%" class="mobile-small" mat-sort-header> Area
      </mat-header-cell>
      <mat-cell *matCellDef="let areas" fxFlex="20%" class="mobile-small" style="margin-right: 8px">
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="subject">
      <mat-header-cell *matHeaderCellDef fxFlex="38%" fxFlex.sm="30%" fxFlex.xs="35%" class="mobile-large"
        mat-sort-header>
        {{ 'Multilang.mesageSubject'| translate }} </mat-header-cell>
      <mat-cell *matCellDef="let message" fxFlex="38%" fxFlex.sm="30%" fxFlex.xs="35%" class="mobile-large">
        <span style="cursor: pointer" matTooltipPosition="after" style="padding-right: 8px">{{message.subject}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="startDate">
      <mat-header-cell *matHeaderCellDef fxFlex="12%" class="mobile-medium" mat-sort-header>
        {{ 'Multilang.startDate'| translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="12%" class="mobile-medium" style="padding-right: 8px">
        {{element.startDate | date:"short"}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="expirationDate">
      <mat-header-cell *matHeaderCellDef fxFlex="12%" class="mobile-medium" mat-sort-header>
        {{ 'Multilang.expirationDate'| translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="12%" class="mobile-medium" style="padding-right: 8px">
        {{element.endDate | date:"short"}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="messageStatusId">
      <mat-header-cell *matHeaderCellDef fxFlex="8%" fxFlex.sm="15%" fxFlex.xs="20%" class="mobile-large">
        {{ 'Multilang.messageStatus'| translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="9%" fxFlex.sm="15%" fxFlex.xs="20%" class="mobile-large"
        style="padding-right: 8px">
        <span>{{ 'Multilang.messageStatus' + element.messageStatusId| translate }}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="messagesRead">
      <mat-header-cell *matHeaderCellDef  fxFlex="10%" class="mobile-medium">
        {{ 'Multilang.messagesRead'| translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="9%" class="mobile-medium">{{element.messagesRead}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="messagesSent">
      <mat-header-cell *matHeaderCellDef fxFlex="7%" class="mobile-medium">
        {{ 'Multilang.messagesSent'| translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="8%" class="mobile-medium" style="padding-right: 8px;">
        {{element.messagesSent}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="price">
      <mat-header-cell *matHeaderCellDef fxFlex="10%" class="mobile-medium">
        {{ 'Multilang.prezzo'| translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="10%" class="mobile-medium">{{element.prezzo| currency:'EUR':true}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Dettagli">
      <mat-header-cell *matHeaderCellDef fxFlex="5%" fxFlex.sm="10%" fxFlex.xs="15%" class="mobile-large">
        {{ 'Multilang.messagesDetail'| translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="5%" fxFlex.sm="10%" fxFlex.xs="15%" class="mobile-large">
        <button type="button" mat-button color="primary" matTooltip="{{ 'Multilang.details'| translate }}"
          style="padding: 0; min-width: 36px;" [routerLink]="['/message-details', element.id]">
          <mat-icon>
            visibility
          </mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="details">
      <mat-header-cell *matHeaderCellDef fxFlex="100%" fxFlex.sm="10%" fxFlex.xs="15%" class="mobile-large">
      </mat-header-cell>
      <mat-cell *matCellDef="let message; let i = index" fxFlex="100%" fxFlex.sm="10%" fxFlex.xs="15%"
        class="mobile-large">
        <!-- <div id="details-container">
          <div id="preview-container">
            <div id="creationtime-container">
              data creazione: {{ message.element.createdDate | date:"short"}}
            </div>
            <div id="subject-container">
              <i *ngIf="message.element.validity === 1" matTooltip="{{ 'Multilang.verification1'| translate }}"
                class="fa fa-clock-o fa-lg mr-2" id="pending-icon" aria-hidden="true"></i>
              <i *ngIf="message.element.validity === 2" matTooltip="{{ 'Multilang.verification2'| translate }}"
                class="fa fa-arrow-right fa-lg mr-2" id="active-icon" aria-hidden="true"></i>
              <i *ngIf="message.element.validity === 3" matTooltip="{{ 'Multilang.verification3'| translate }}"
                class="fa fa-check fa-lg mr-2" id="expired-icon" aria-hidden="true"></i>
              <i *ngIf="message.element.validity === 4" matTooltip="{{ 'Multilang.verification4'| translate }}"
                class="fa fa-times fa-lg mr-2" id="cancelled-icon" aria-hidden="true"></i>
              {{ message.element.subject }}
            </div>
            <div id="body-container">
              {{ message.element.body }}
            </div>
            <div id="url-container">
              <a href="{{ message.element.url }}" target="_blank">{{ message.element.url }}</a>
            </div>
            <div id="category-container">
              {{ message.element.categoryName }}
            </div>
            <div id="sender-container">
              {{ message.element.senderName }}
            </div>
          </div>
          <div id="core-details-container">
            <div id="map-container" [ngClass]="!mapDisplayed ? 'map-collapsed' : 'map-expanded'">
              <app-detail-map-v2 *ngIf="i == mapToLoadIndex" [aree]="message.element.area"></app-detail-map-v2>
            </div>
            <div id="media-container">
              <span id="date-label">Pannello di controllo</span>
              <div class="control-panel">
                <a mat-stroked-button class="control-panel-item button-link" href="{{message.element.multimediaLink}}"
                  target="_blank" (click)="mostraAllegato(message.element.multimediaName)"
                  [disabled]="!(message.element.multimediaLink)">Visualizza multimedia</a>
                <button mat-stroked-button class="control-panel-item" (click)="extendMessage(message.element)"
                  [disabled]="!(message.element.validity == 1 || message.element.validity == 2)">Proroga
                  messaggio</button>
                <button #terminateButton mat-stroked-button class="control-panel-item" color="warn"
                  (click)="terminateMessage(message.element.id)"
                  [disabled]="message.element.validity === 4 || message.element.validity === 3">Termina
                  messaggio</button>
              </div>
            </div>
            <div id="times-container">
              <span id="date-label">Periodo di validità</span>
              <div id="startDate-container">
                <div class="date-field"> da {{ message.element.startDate | date:"EEEE dd/LL/y HH:mm" }} </div>
              </div>
              <div id="endDate-container">
                <div class="date-field"> a {{ message.element.endDate | date:"EEEE dd/LL/y HH:mm" }} </div>
              </div>
            </div>
          </div>
          <div class="text-center" (click)="closeRow()">
            <button mat-stroked-button id="actions-container" color="primary">
              <i class="fa fa-angle-double-up fa-2x" id="close-icon" aria-hidden="true"></i>
            </button>
          </div>
        </div> -->
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef=" displayedColumns; sticky: true" style="height: 64px">
    </mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row" (click)="onMessageDetail(row)">
    </mat-row>
    <!-- <mat-row *matRowDef="let row; columns: ['details']; when: isExpansionDetailRow; let i = index" class="detail-row"
      [class.expanded]="expandedElement == row"
      [@detailExpand]="row.element == expandedElement ? 'expanded' : 'collapsed'" style="overflow: hidden">
    </mat-row> -->
  </mat-table>
</div>

<div class="loading" *ngIf="sub === true">
</div>
